<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
         <div class="card m-2 m-lg-3">
        <div class="card-body">
               <div class="row mb-md-4 align-items-center form-header">
            <div class="col mt-4 d-none d-sm-block" >
              <h4 class="ms-lg-4 ms-md-2">View Salary User Details</h4>
            </div>
            <div class="col mt-4 d-block  d-sm-none">
                <h5>View Salary User</h5>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                 Back To Salary Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
        
            <!-- Check if selectedLandlord is available before rendering the data -->
            <div class="col-lg-8 col-md-12 col-sm-12 m-lg-4 m-md-2">
             
              <div class="card p-4">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="nameLabel">Name:</llp-label>
                    <llp-input
                      id="nameId"
                      class="w-100"
                      autocomplete="off"
                      v-model="name"
                      disabled
                    ></llp-input>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="mobileLabel" :aria-label="Mobile"
                      >Mobile:</llp-label
                    >
                    <llp-input
                      id="mobileInput"
                      v-model="mobile"
                      class="w-100"
                      autocomplete="off"
                      disabled
                    ></llp-input>
                  </div>
                </div>
                 <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="panId" :aria-label="name"
                      >Pan Number:</llp-label
                    >
                    <llp-input
                      id="PanInput"
                      v-model="pan"
                      class="w-100"
                      autocomplete="off"
                      disabled
                    ></llp-input>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="AddressId" :aria-label="Lastname"
                      >Address:</llp-label
                    >
                    <llp-input
                      id="AddressInput"
                      v-model="address"
                      class="w-100"
                      autocomplete="off"
                      disabled
                    ></llp-input>
                  </div>
                </div>
   <div class="row">

                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="panId" :aria-label="name">Salary:</llp-label>
                    <llp-input
                      id="SalaryInput"
                      v-model="salary"
                      class="w-100"
                      autocomplete="off"
                      disabled
                    ></llp-input>
                  </div>
                </div>
                <h5 class="mt-2 fw-bold bank-details">Bank Info</h5>
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div class="card mb-4">
                      <div class="card-body">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="accountNumber" :aria-label="AccountNumber"
                      >Account Number:</llp-label
                    >
                    <llp-input
                      id="MonthlyRentInput"
                      v-model="accountNumber"
                      class="w-100"
                      autocomplete="off"
                      disabled
                    ></llp-input>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="pincodeLabel" :aria-label="name"
                      >Account Holder Name:</llp-label
                    >
                    <llp-input
                      id="accountName"
                      class="w-100"
                      autocomplete="off"
                      v-model="accountHolderName"
                      disabled
                      
                    ></llp-input>
                  </div>
                </div>
                <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Bank Name:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="bankName"
                        disabled
                      />
                    </div>
                 
                 <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>IFSC Code:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="ifscCode"
                        disabled
                      />
                    </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Branch:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="branch"
                        disabled
                      />
                    </div>
                </div>
                      </div>
                    </div>
                  </div>

              </div>
            </div>
         

       
        </div>
      </div>
      </div>
     
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";

export default {
data() {
    return {
      name: "",
      mobile: "",
      pan: "",
      address: "",
      accountNumber: "",
      bankName: "",
      accountHolderName: "",
      ifscCode: "",
      salary: "",
      branch:"",
      offerLatter: null,
      offerLatterError: "",
      availableIfscCodes: {},
       bankData: [],
      serviceId:this.$route.params.serviceId,
      userId:localStorage.getItem('User_id'),
      itemId:this.$route.params.id,
    };
  },
 
 mounted()
 {
this.fetchingSalaryDetails();
 },
  methods: {
    BackToServices() {
      this.$router.back();
    },
     async fetchingSalaryDetails()
    {

      try {
        const caRelatedResponse = await NetworkService.get(`/get-service-list-edit/${this.itemId}/${this.userId}/${this.serviceId}`);
        this.userDetails = caRelatedResponse.details;
        this.name = this.userDetails.name;
        this.mobile = this.userDetails.mobile;
        this.pan = this.userDetails.pan_number ? "*".repeat(this.userDetails.pan_number.length - 4) + this.userDetails.pan_number.slice(-4) : "";
        this.address = this.userDetails.address;
        this.salary = this.userDetails.salary;
        this.accountHolderName = this.userDetails.account_holder_name;
        this.accountNumber=this.userDetails.account_number;
        this.bankName=this.userDetails.bank_name;
        this.ifscCode = this.userDetails.ifsc_code;
        this.branch = this.userDetails.bank_branch
      } catch (error) {
       if(error.message)
       {
        this.$refs.toast.show(error.message,"error")
       }else{
         this.$refs.toast.show(
              "Unable to fetching the salary payment details",
              "error"
            );
       }
      }
    },
  },
};
</script>

